var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pb-0 px-0 secondary",class:{'isCheckout': _vm.isCheckout},attrs:{"fluid":""}},[_c('MainHeader',{attrs:{"isCheckout":_vm.isCheckout}}),_c('div',{staticClass:"primary dark-background-height"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }